<template>
  <div style="border: 1px solid #ccc;" >
    <Toolbar
      v-if="showToolbar"
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      :style="{height: height}"
      style="overflow-y: hidden;"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import _ from 'lodash';
export default {
  name: 'WangEditor',
  components: { Editor, Toolbar },
  props: {
    defaultHtml: {
      type: String,
      default () {
        return ''
      }
    },
    height: {
      type: String,
      default () {
        return '300px';
      }
    },
    showToolbar: {
      type: Boolean,
      default () {
        return true
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请输入内容...'
      }
    }
  },
  data () {
    return {
      editor: null,
      html: '',
      toolbarConfig: {
        /* 工具栏配置 */
        // toolbarKeys: [
        //   'headerSelect',
        //   '|',
        //   'bold',
        //   'italic',
        //   'underline',
        //   'through',
        //   'color',
        //   'bgColor',
        //   'insertTable',
        //   'uploadImage',
        //   '|',
        //   'redo',
        //   'undo',
        //   'fullScreen'
        // ]
        // excludeKeys: ['group-video']
      },
      editorConfig: {
        placeholder: this.placeholder,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            customUpload: async (file, insertFn) => {
              const resultUrl = await this.uploadImg(file);
              insertFn(resultUrl);
            }
          }
        }
      },
      mode: 'default' // or 'simple'
    }
  },
  filters: {},
  computed: {},
  watch: {
  },
  methods: {
    uploadImg (file) {
      const data = new FormData()
      data.append('file', file)
      return new Promise((resolve, reject) => {
        this.$api.common.uploadImg(data).then(res => {
          resolve(res.url)
        }).catch(err => {
          reject(err)
        })
      })
    },
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      this.editor.setHtml(this.defaultHtml)
    },
    onChange: _.debounce(function () {
      this.$emit('change', this.html)
    }, 500)
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {

  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  destroyed () {
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>

</style>
